import { FC, MouseEventHandler, SVGProps } from "react";

export type ButtonType =
  | "primary"
  | "secondary"
  | "tertiary"
  | "disabled"
  | "danger"
  | "ghost";

const primaryButtonStyles =
  "text-white bg-black hover:bg-stone-900 dark:text-black dark:bg-white dark:hover:bg-stone-100";
const secondaryButtonStyles =
  "text-stone-700 border border-stone-300! dark:text-white bg-stone-50 dark:border-0 dark:bg-stone-500 hover:bg-stone-600 dark:hover:bg-stone-600 hover:text-white";
const tertiaryButtonStyles =
  "text-stone-700 dark:text-stone-300 border border-stone-500 text-stone-600 hover:text-white hover:bg-stone-600";
const disabledButtonStyles = "bg-stone-200 text-stone-400";
const dangerButtonStyles = "text-white bg-red-500 hover:bg-red-600";
const ghostButtonStyles =
  "shadow-none text-stone-500 hover:bg-stone-200 dark:hover:bg-stone-600";

const buttonTypeColors: Record<ButtonType, string> = {
  primary: primaryButtonStyles,
  secondary: secondaryButtonStyles,
  tertiary: tertiaryButtonStyles,
  disabled: disabledButtonStyles,
  danger: dangerButtonStyles,
  ghost: ghostButtonStyles,
};

type ButtonAttrs = React.ButtonHTMLAttributes<HTMLButtonElement>;

type ButtonTypes = {
  buttonType?: Exclude<ButtonType, "disabled">;
  children?: SVGProps<SVGSVGElement>;
  ref?: React.MutableRefObject<null>;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  title: string;
};

type ButtonProps = ButtonTypes & ButtonAttrs;

export const Button: FC<ButtonProps> = ({
  buttonType = "primary",
  onClick,
  title,
  children,
  className,
  ...args
}) => {
  const generalStyle =
    "flex justify-center align-center rounded-md border border-transparent px-4 py-2 text-sm font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-stone-500 mt-8";
  const colors = buttonTypeColors[args.disabled ? "disabled" : buttonType];
  const isIcon = !!children;
  const styles = `${className ?? generalStyle} ${colors}`;

  return (
    <button className={styles} key={buttonType} onClick={onClick} {...args}>
      {children}
      <span className={`${isIcon ? "hidden sm:inline" : ""}`}>{title}</span>
    </button>
  );
};
